"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get COMMON_DELETE_ROLES () {
        return COMMON_DELETE_ROLES;
    },
    get COMMON_DELETE_ROLES_SET () {
        return COMMON_DELETE_ROLES_SET;
    },
    get CREATOR_AND_UP () {
        return CREATOR_AND_UP;
    },
    get CREATOR_AND_UP_SET () {
        return CREATOR_AND_UP_SET;
    },
    get EXTERNAL_ROLES () {
        return EXTERNAL_ROLES;
    },
    get EXTERNAL_ROLES_SET () {
        return EXTERNAL_ROLES_SET;
    },
    get GUEST () {
        return GUEST;
    },
    get INTERNAL_ROLES () {
        return INTERNAL_ROLES;
    },
    get INTERNAL_ROLES_SET () {
        return INTERNAL_ROLES_SET;
    },
    get Policies () {
        return Policies;
    },
    get RESOURCE_NAME () {
        return RESOURCE_NAME;
    },
    get RoleName () {
        return RoleName;
    },
    get RoleNames () {
        return RoleNames;
    },
    get UserRoleName () {
        return UserRoleName;
    },
    get UserRoleNames () {
        return UserRoleNames;
    },
    get resourcePermissionRequiresPII () {
        return resourcePermissionRequiresPII;
    }
});
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
const UserRoleNames = [
    "manager",
    "member",
    "creator",
    "view_only"
];
const UserRoleName = {
    manager: "manager",
    member: "member",
    creator: "creator",
    view_only: "view_only"
};
const RoleNames = [
    ...UserRoleNames,
    "admin",
    "guest",
    "publicUser"
];
const RoleName = {
    admin: "admin",
    guest: "guest",
    publicUser: "publicUser",
    manager: "manager",
    member: "member",
    creator: "creator",
    view_only: "view_only"
};
const GUEST = [
    "guest"
];
const EXTERNAL_ROLES = [
    "guest",
    "publicUser"
];
const EXTERNAL_ROLES_SET = new Set(EXTERNAL_ROLES);
const INTERNAL_ROLES = [
    "view_only",
    "creator",
    "member",
    "manager",
    "admin"
];
const INTERNAL_ROLES_SET = new Set(INTERNAL_ROLES);
const CREATOR_AND_UP = [
    "creator",
    "member",
    "manager",
    "admin"
];
const CREATOR_AND_UP_SET = new Set(CREATOR_AND_UP);
const COMMON_DELETE_ROLES = [
    "member",
    "manager",
    "admin"
];
const COMMON_DELETE_ROLES_SET = new Set(COMMON_DELETE_ROLES);
var RESOURCE_NAME = /*#__PURE__*/ function(RESOURCE_NAME) {
    RESOURCE_NAME["ACCOUNT"] = "account";
    RESOURCE_NAME["ACCOUNT_CONTACT_INFORMATION"] = "accountContactInformation";
    RESOURCE_NAME["ACCOUNT_PROPERTY_WARNING"] = "accountPropertyWarning";
    RESOURCE_NAME["ACTIVITY"] = "activity";
    RESOURCE_NAME["ADMIN"] = "admin";
    RESOURCE_NAME["AI_ACTION"] = "aiAction";
    RESOURCE_NAME["AI_ACTION_RUN_RESULT"] = "aiActionRun";
    RESOURCE_NAME["AI_FEEDBACK"] = "aiFeedback";
    RESOURCE_NAME["API_KEY"] = "apiKey";
    RESOURCE_NAME["APP"] = "app";
    RESOURCE_NAME["ARCGIS_EXPORT_CONFIGURATION"] = "arcGISExportConfiguration";
    RESOURCE_NAME["BASE_MAP"] = "baseMap";
    RESOURCE_NAME["BULK_ACTION"] = "bulkAction";
    RESOURCE_NAME["CERTIFICATE"] = "certificate";
    RESOURCE_NAME["CERTIFICATE_UPLOAD"] = "certificateUpload";
    RESOURCE_NAME["CERTIFICATE_ERROR"] = "certificateError";
    RESOURCE_NAME["COMMENT"] = "comment";
    RESOURCE_NAME["CUSTOM_MAP"] = "customMap";
    RESOURCE_NAME["CUSTOM_MAP_GEOMETRY"] = "customMapGeometry";
    RESOURCE_NAME["CUSTOM_OBJECT_GROUP"] = "customObjectGroup";
    RESOURCE_NAME["DESIGN_FLOOD_ELEVATION"] = "designFloodElevation";
    RESOURCE_NAME["DOCUMENT_TEMPLATE"] = "documentTemplate";
    RESOURCE_NAME["DOCUMENT_UPLOAD"] = "documentUpload";
    RESOURCE_NAME["FEATURE_FLAG"] = "featureFlag";
    RESOURCE_NAME["FEATURED_CONTENT"] = "featuredContent";
    RESOURCE_NAME["FIRM"] = "firm";
    RESOURCE_NAME["GENERATED_DOCUMENT"] = "generatedDocument";
    RESOURCE_NAME["USER_GROUP"] = "userGroup";
    RESOURCE_NAME["HEALTH_CHECK"] = "healthCheck";
    RESOURCE_NAME["HELPSCOUT_BEACON"] = "helpscoutBeacon";
    RESOURCE_NAME["INFORMATION_REQUEST"] = "informationRequest";
    RESOURCE_NAME["IMPROVEMENT"] = "improvement";
    RESOURCE_NAME["ISSUE"] = "issue";
    RESOURCE_NAME["DATA_SETTINGS"] = "dataSettings";
    RESOURCE_NAME["MAILING"] = "mailing";
    RESOURCE_NAME["OFFLINE_PACK"] = "offlinePack";
    RESOURCE_NAME["PARCEL"] = "parcel";
    RESOURCE_NAME["PARCEL_IMPORT_TASK"] = "parcelImportTask";
    RESOURCE_NAME["PARCEL_IMPORT_CONFIGURATION"] = "parcelImportConfiguration";
    RESOURCE_NAME["PASSWORD_RESET"] = "passwordReset";
    RESOURCE_NAME["PERMIT"] = "permit";
    RESOURCE_NAME["PROPERTY"] = "property";
    RESOURCE_NAME["PROPERTY_ATTRIBUTE"] = "propertyAttribute";
    RESOURCE_NAME["PUBLIC_ACCOUNT_PORTAL"] = "publicAccountPortal";
    RESOURCE_NAME["PUBLIC_USER"] = "publicUser";
    RESOURCE_NAME["RASTER"] = "raster";
    RESOURCE_NAME["REPETITIVE_LOSS"] = "repetitiveLoss";
    RESOURCE_NAME["REPETITIVE_LOSS_IMPORT_JOB"] = "repetitiveLossImportJob";
    RESOURCE_NAME["ROOT"] = "root";
    RESOURCE_NAME["RULE_DEFINITION"] = "ruleDefinition";
    RESOURCE_NAME["SAVED_VIEW"] = "savedView";
    RESOURCE_NAME["SEARCH"] = "search";
    RESOURCE_NAME["SECURITY_CONFIGURATION"] = "securityConfiguration";
    RESOURCE_NAME["SCRIPT_JOB"] = "scriptJob";
    RESOURCE_NAME["SUBMISSION"] = "submission";
    RESOURCE_NAME["SUBMISSION_TYPE"] = "submissionType";
    RESOURCE_NAME["SUBMISSION_SUMMARY"] = "submissionSummary";
    RESOURCE_NAME["TASK"] = "task";
    RESOURCE_NAME["THIRD_PARTY_SYSTEM_CONFIGURATION"] = "thirdPartySystemConfiguration";
    RESOURCE_NAME["TRANSCRIPTION_TASK"] = "transcriptionTask";
    RESOURCE_NAME["USER"] = "user";
    RESOURCE_NAME["USER_INVITE"] = "userInvite";
    RESOURCE_NAME["PAGINATION_INFO"] = "paginationInfo";
    RESOURCE_NAME["PUBLIC_USER_INVITE"] = "publicUserInvite";
    RESOURCE_NAME["WARNING"] = "warning";
    RESOURCE_NAME["MOBILE_VERSION"] = "mobileVersion";
    RESOURCE_NAME["USER_DEVICE"] = "userDevice";
    RESOURCE_NAME["USER_DEVICE_LOCATION"] = "userDeviceLocation";
    RESOURCE_NAME["QUERY_DESCRIPTION"] = "queryDescription";
    RESOURCE_NAME["WORKFLOW"] = "workflow";
    RESOURCE_NAME["WORKFLOW_STEP"] = "workflowStep";
    RESOURCE_NAME["WORKFLOW_DEFINITION"] = "workflowDefinition";
    return RESOURCE_NAME;
}({});
const Policies = {
    ["account"]: {
        find: new Set([
            "*"
        ]),
        view: {
            guest: new Set([
                "id",
                "name",
                "state",
                "bounds",
                "freeboard",
                "projectTracking",
                "cumulativeTrackingPeriod",
                "projectThresholdPercentage",
                "propertyAdjustmentRatio",
                "firms",
                "datums",
                "coastalADetermination",
                "dfeDeterminationMethod",
                "featureFlags",
                "crsEnabled",
                "ecErrorDetectionEnabled",
                "ecErrorDetectionStartDate",
                "repetitiveLossEnabled",
                "baseMaps",
                "isPilot",
                "contactInformation",
                "publicPortal",
                "accountDocumentTypes",
                "logoUrl",
                "parcelFieldNameOverrides",
                "securityConfiguration",
                "disclaimerOverrides",
                "subdomain",
                "logoUrl",
                "userGroups",
                "isSSOEnabled",
                "ssoProviders"
            ]),
            publicUser: new Set([
                "id",
                "name",
                "state",
                "bounds",
                "freeboard",
                "projectTracking",
                "cumulativeTrackingPeriod",
                "projectThresholdPercentage",
                "propertyAdjustmentRatio",
                "firms",
                "datums",
                "coastalADetermination",
                "dfeDeterminationMethod",
                "featureFlags",
                "crsEnabled",
                "ecErrorDetectionEnabled",
                "ecErrorDetectionStartDate",
                "repetitiveLossEnabled",
                "baseMaps",
                "isPilot",
                "contactInformation",
                "publicPortal",
                "accountDocumentTypes",
                "logoUrl",
                "parcelFieldNameOverrides",
                "securityConfiguration",
                "disclaimerOverrides",
                "subdomain",
                "logoUrl",
                "userGroups",
                "isSSOEnabled",
                "ssoProviders"
            ]),
            view_only: new Set([
                "*"
            ]),
            creator: new Set([
                "*"
            ]),
            member: new Set([
                "*"
            ]),
            manager: new Set([
                "*"
            ]),
            admin: new Set([
                "*"
            ])
        },
        list: new Set([
            "admin"
        ]),
        update: new Set([
            "manager",
            "admin"
        ]),
        updateDisclaimerOverrides: new Set([
            "admin"
        ]),
        create: new Set([
            "admin"
        ]),
        updateSupportedLanguages: new Set([
            "manager",
            "admin"
        ])
    },
    ["accountContactInformation"]: {
        view: new Set([
            "*"
        ])
    },
    ["accountPropertyWarning"]: {
        create: new Set([
            "creator",
            "manager",
            "admin"
        ]),
        update: new Set([
            "creator",
            "manager",
            "admin"
        ]),
        delete: new Set([
            "creator",
            "manager",
            "admin"
        ])
    },
    ["activity"]: {
        view: new Set([
            "view_only",
            "creator",
            "member",
            "manager",
            "admin"
        ]),
        list: new Set([
            "view_only",
            "creator",
            "member",
            "manager",
            "admin"
        ]),
        export: new Set([
            "admin"
        ]),
        delete: new Set([
            "admin"
        ])
    },
    ["admin"]: {
        find: new Set([
            "*"
        ]),
        login: new Set([
            "*"
        ]),
        view: {
            admin: new Set([
                "*"
            ]),
            view_only: new Set([
                "firstName",
                "lastName",
                "id"
            ]),
            creator: new Set([
                "firstName",
                "lastName",
                "id"
            ]),
            member: new Set([
                "firstName",
                "lastName",
                "id"
            ]),
            manager: new Set([
                "firstName",
                "lastName",
                "id"
            ])
        }
    },
    ["app"]: {
        view: new Set([
            "*"
        ])
    },
    ["arcGISExportConfiguration"]: {
        view: new Set([
            "admin"
        ]),
        create: new Set([
            "admin"
        ]),
        update: new Set([
            "admin"
        ]),
        delete: new Set([
            "admin"
        ])
    },
    ["baseMap"]: {
        view: new Set([
            "*"
        ]),
        list: new Set([
            "*"
        ]),
        create: new Set([
            "admin"
        ]),
        delete: new Set([
            "admin"
        ]),
        update: new Set([
            "admin"
        ])
    },
    ["bulkAction"]: {
        view: INTERNAL_ROLES_SET,
        dispatch: CREATOR_AND_UP_SET
    },
    ["certificate"]: {
        find: new Set([
            "*"
        ]),
        view: {
            guest: new Set([
                "id",
                "issuedAt",
                "documentUpload",
                "type",
                "property",
                "certificateUpload",
                "address",
                "elevationDatum",
                "nfipCountyName",
                "nfipState",
                "benchmarkUtilized",
                "buildingUse",
                "buildingDiagramNumber",
                "crawlspaceSqft",
                "numCrawlspaceFloodOpenings",
                "netAreaOfCrawlspaceFloodOpenings",
                "engineeredCrawlspaceFloodOpenings",
                "garageSqft",
                "numGarageFloodOpenings",
                "netAreaOfGarageFloodOpenings",
                "engineeredGarageFloodOpenings",
                "firmIndexDate",
                "firmPanelEffectiveDate",
                "floodZone",
                "baseFloodElevation",
                "baseFloodElevationDatum",
                "baseFloodElevationDatumOther",
                "fiveHundredYearFloodElevation",
                "comments",
                "coordinatesProvidedBySurveyor",
                "conversionFactorUsed",
                "buildingElevationSource",
                "propertyDescription",
                "topOfBottomFloor",
                "topOfNextHigherFloor",
                "bottomOfLowestHorizontalStructuralMember",
                "attachedGarage",
                "lowestElevationOfMachineryOrEquipment",
                "lowestAdjacentGrade",
                "lowestAdjacentGradeType",
                "highestAdjacentGrade",
                "highestAdjacentGradeType",
                "lowestAdjacentGradeAtLowestElevationOfDeckOrStairs",
                "buildingElevationInfo",
                "lowestFloorElevationField",
                "buildingElevations",
                "validationErrors",
                "streetAddress",
                "state",
                "city",
                "zipcode",
                "certifierName",
                "certifierLicenseNumber",
                "certifierInfo",
                "propertyOwnerInfo",
                "firmMapNumber",
                "hiddenFromPublic",
                "formYear",
                "regulatoryLowestFloorElevation",
                "nfipLowestFloorElevation",
                "regulatoryLowestFloorElevationDetails",
                "nfipLowestFloorElevationDetails",
                "attachedGarageInfo",
                "crawlspaceInfo",
                "sqft",
                "netAreaOfFloodOpenings",
                "numFloodOpenings",
                "engineeredFloodOpenings",
                "oneFloodOpeningTwoSides",
                "numNonEngineeredOpenings",
                "numEngineeredOpenings",
                "netAreaNonEngineeredOpenings",
                "ratedAreaOfEngineeredOpenings",
                "telephone",
                "email",
                "licenseNumber",
                "name",
                "sealPresent",
                "signaturePresent",
                "permit",
                "communityInfo",
                "buildingMeasurementInfo",
                "finishedConstruction",
                "extractedData",
                "firmSuffix",
                "nfipCommunityNumber",
                "nfipCommunityName",
                "elevationDatumComments",
                "verticalDatum",
                "buildingLocatedSeawardOfLimwa",
                "buildingLocatedInCbrsOrOpa",
                "buildingLocatedInCbrsOrOpaDesignationDate",
                "isBuildingLocatedInCbrsOrOpa",
                "baseFloodElevationSource",
                "longitude",
                "latitude",
                "horizontalDatum",
                "errorDetectionEligibility",
                "buildingOwnerName",
                "measurementsBasedOn",
                "topOfBottomFloorElevatedPerOrdinance",
                "offsets",
                "sectionCTakenFromOtherAuthorizedSource",
                "sectionECompletedByLocalOfficial",
                "sectionHCompletedByLocalOfficial",
                "sectionGCommentsProvidedByLocalOfficial",
                "communityInfoProvidedForFloodplainManagementPurposes",
                "permitNumber",
                "permitDateIssued",
                "certificateOfComplianceOrOccupancyDateIssued",
                "permitIssuedForNewConstructionOrSI",
                "elevations",
                "varianceIssued",
                "localOfficialInfo",
                "firms",
                "pageHeaderAddressesAreConsistent",
                "everyPageHasHeaderAddress",
                "numberOfPhotosProvided",
                "elevationDatumOther",
                "everyPhotoIsInColor",
                "date"
            ]),
            publicUser: new Set([
                "id",
                "issuedAt",
                "documentUpload",
                "type",
                "property",
                "certificateUpload",
                "address",
                "elevationDatum",
                "nfipCountyName",
                "nfipState",
                "benchmarkUtilized",
                "buildingUse",
                "buildingDiagramNumber",
                "crawlspaceSqft",
                "numCrawlspaceFloodOpenings",
                "netAreaOfCrawlspaceFloodOpenings",
                "engineeredCrawlspaceFloodOpenings",
                "garageSqft",
                "numGarageFloodOpenings",
                "netAreaOfGarageFloodOpenings",
                "engineeredGarageFloodOpenings",
                "firmIndexDate",
                "firmPanelEffectiveDate",
                "floodZone",
                "baseFloodElevation",
                "baseFloodElevationDatum",
                "baseFloodElevationDatumOther",
                "fiveHundredYearFloodElevation",
                "comments",
                "coordinatesProvidedBySurveyor",
                "conversionFactorUsed",
                "buildingElevationSource",
                "propertyDescription",
                "topOfBottomFloor",
                "topOfNextHigherFloor",
                "bottomOfLowestHorizontalStructuralMember",
                "attachedGarage",
                "lowestElevationOfMachineryOrEquipment",
                "lowestAdjacentGrade",
                "lowestAdjacentGradeType",
                "highestAdjacentGrade",
                "highestAdjacentGradeType",
                "lowestAdjacentGradeAtLowestElevationOfDeckOrStairs",
                "buildingElevationInfo",
                "lowestFloorElevationField",
                "buildingElevations",
                "validationErrors",
                "streetAddress",
                "state",
                "city",
                "zipcode",
                "certifierName",
                "certifierLicenseNumber",
                "certifierInfo",
                "propertyOwnerInfo",
                "firmMapNumber",
                "hiddenFromPublic",
                "formYear",
                "regulatoryLowestFloorElevation",
                "nfipLowestFloorElevation",
                "regulatoryLowestFloorElevationDetails",
                "nfipLowestFloorElevationDetails",
                "attachedGarageInfo",
                "crawlspaceInfo",
                "sqft",
                "netAreaOfFloodOpenings",
                "numFloodOpenings",
                "engineeredFloodOpenings",
                "oneFloodOpeningTwoSides",
                "numNonEngineeredOpenings",
                "numEngineeredOpenings",
                "netAreaNonEngineeredOpenings",
                "ratedAreaOfEngineeredOpenings",
                "telephone",
                "email",
                "licenseNumber",
                "name",
                "sealPresent",
                "signaturePresent",
                "permit",
                "communityInfo",
                "buildingMeasurementInfo",
                "finishedConstruction",
                "extractedData",
                "firmSuffix",
                "nfipCommunityNumber",
                "nfipCommunityName",
                "elevationDatumComments",
                "verticalDatum",
                "buildingLocatedSeawardOfLimwa",
                "buildingLocatedInCbrsOrOpa",
                "buildingLocatedInCbrsOrOpaDesignationDate",
                "isBuildingLocatedInCbrsOrOpa",
                "baseFloodElevationSource",
                "longitude",
                "latitude",
                "horizontalDatum",
                "errorDetectionEligibility",
                "buildingOwnerName",
                "measurementsBasedOn",
                "topOfBottomFloorElevatedPerOrdinance",
                "offsets",
                "sectionCTakenFromOtherAuthorizedSource",
                "sectionECompletedByLocalOfficial",
                "sectionHCompletedByLocalOfficial",
                "sectionGCommentsProvidedByLocalOfficial",
                "communityInfoProvidedForFloodplainManagementPurposes",
                "permitNumber",
                "permitDateIssued",
                "certificateOfComplianceOrOccupancyDateIssued",
                "permitIssuedForNewConstructionOrSI",
                "elevations",
                "varianceIssued",
                "localOfficialInfo",
                "firms",
                "pageHeaderAddressesAreConsistent",
                "everyPageHasHeaderAddress",
                "numberOfPhotosProvided",
                "elevationDatumOther",
                "everyPhotoIsInColor",
                "date"
            ]),
            view_only: new Set([
                "*"
            ]),
            creator: new Set([
                "*"
            ]),
            member: new Set([
                "*"
            ]),
            manager: new Set([
                "*"
            ]),
            admin: new Set([
                "*"
            ])
        },
        hide: new Set([
            "creator",
            "member",
            "manager",
            "admin"
        ]),
        export: new Set([
            "creator",
            "member",
            "manager",
            "admin"
        ]),
        updateSettings: new Set([
            "admin"
        ]),
        update: new Set([
            "member",
            "manager",
            "admin"
        ])
    },
    ["certificateError"]: {
        view: {
            guest: new Set([
                "data",
                "count",
                "id",
                "errorCode",
                "issue",
                "type",
                "value",
                "field",
                "note",
                "valueAttr",
                "ignored"
            ]),
            publicUser: new Set([
                "data",
                "count",
                "id",
                "errorCode",
                "issue",
                "type",
                "value",
                "field",
                "note",
                "valueAttr",
                "ignored"
            ]),
            view_only: new Set([
                "*"
            ]),
            creator: new Set([
                "*"
            ]),
            member: new Set([
                "*"
            ]),
            manager: new Set([
                "*"
            ]),
            admin: new Set([
                "*"
            ])
        },
        update: new Set([
            "creator",
            "member",
            "manager",
            "admin"
        ]),
        generateSummary: new Set([
            "creator",
            "member",
            "manager",
            "admin",
            "view_only"
        ])
    },
    ["certificateUpload"]: {
        view: {
            guest: new Set([
                "id",
                "status"
            ]),
            publicUser: new Set([
                "id",
                "status"
            ]),
            view_only: new Set([
                "*"
            ]),
            creator: new Set([
                "*"
            ]),
            member: new Set([
                "*"
            ]),
            manager: new Set([
                "*"
            ]),
            admin: new Set([
                "*"
            ])
        },
        bulk_create: new Set([
            "admin"
        ]),
        cancel: new Set([
            "admin"
        ]),
        update: new Set([
            "member",
            "manager",
            "admin"
        ])
    },
    ["comment"]: {
        view: new Set([
            "view_only",
            "creator",
            "member",
            "manager",
            "admin"
        ]),
        create: new Set([
            "creator",
            "member",
            "manager",
            "admin"
        ]),
        delete: new Set([
            "creator",
            "member",
            "manager",
            "admin"
        ]),
        list: new Set([
            "view_only",
            "creator",
            "member",
            "manager",
            "admin"
        ])
    },
    ["customMap"]: {
        view: {
            guest: new Set([
                "customMaps",
                "id",
                "name",
                "labelsVisibleOnMap",
                "isDefault",
                "isObject",
                "searchEnabled",
                "legend",
                "type",
                "tileset",
                "sources",
                "config",
                "geometries",
                "allowsCreation",
                "defaultStyles"
            ]),
            publicUser: new Set([
                "customMaps",
                "id",
                "name",
                "labelsVisibleOnMap",
                "isDefault",
                "isObject",
                "searchEnabled",
                "legend",
                "type",
                "tileset",
                "sources",
                "config",
                "geometries",
                "allowsCreation",
                "defaultStyles"
            ]),
            view_only: new Set([
                "*"
            ]),
            creator: new Set([
                "*"
            ]),
            member: new Set([
                "*"
            ]),
            manager: new Set([
                "*"
            ]),
            admin: new Set([
                "*"
            ])
        },
        viewIntersections: new Set([
            "guest",
            "publicUser",
            "view_only",
            "creator",
            "member",
            "manager",
            "admin"
        ]),
        viewGeometryCount: new Set([
            "view_only",
            "creator",
            "member",
            "manager",
            "admin"
        ]),
        create: new Set([
            "admin"
        ]),
        update: new Set([
            "admin"
        ]),
        delete: new Set([
            "admin"
        ])
    },
    ["customMapGeometry"]: {
        view: {
            guest: new Set([
                "customMapGeometry",
                "customMap",
                "documentUploads",
                "id",
                "label",
                "sourceId",
                "bounds",
                "interiorPoint",
                "additionalFields",
                "customMapId",
                "coverImageDocumentUploadId"
            ]),
            publicUser: new Set([
                "customMapGeometry",
                "customMap",
                "documentUploads",
                "id",
                "label",
                "sourceId",
                "bounds",
                "interiorPoint",
                "additionalFields",
                "customMapId",
                "coverImageDocumentUploadId"
            ]),
            view_only: new Set([
                "*"
            ]),
            creator: new Set([
                "*"
            ]),
            member: new Set([
                "*"
            ]),
            manager: new Set([
                "*"
            ]),
            admin: new Set([
                "*"
            ])
        },
        create: new Set([
            "creator",
            "member",
            "manager",
            "admin"
        ]),
        update: new Set([
            "creator",
            "member",
            "manager",
            "admin"
        ]),
        share: new Set([
            "view_only",
            "creator",
            "member",
            "manager",
            "admin"
        ]),
        delete: COMMON_DELETE_ROLES_SET
    },
    ["customObjectGroup"]: {
        view: new Set([
            "*"
        ]),
        create: new Set([
            "admin"
        ]),
        update: new Set([
            "admin"
        ]),
        delete: new Set([
            "admin"
        ])
    },
    ["designFloodElevation"]: {
        list: new Set([
            "view_only",
            "creator",
            "member",
            "manager",
            "admin"
        ]),
        view: new Set([
            "*"
        ]),
        update: new Set([
            "creator",
            "member",
            "manager",
            "admin"
        ])
    },
    ["documentTemplate"]: {
        create: new Set([
            "admin"
        ]),
        delete: new Set([
            "admin"
        ]),
        list: new Set([
            "view_only",
            "creator",
            "member",
            "manager",
            "admin"
        ]),
        update: new Set([
            "admin"
        ]),
        view: {
            view_only: new Set([
                "id",
                "name",
                "accountDocumentType",
                "customMapId",
                "submissionTypeId",
                "documentUploadFormDataPath"
            ]),
            creator: new Set([
                "id",
                "name",
                "accountDocumentType",
                "customMapId",
                "submissionTypeId",
                "documentUploadFormDataPath"
            ]),
            member: new Set([
                "id",
                "name",
                "accountDocumentType",
                "customMapId",
                "submissionTypeId",
                "documentUploadFormDataPath"
            ]),
            manager: new Set([
                "id",
                "name",
                "accountDocumentType",
                "customMapId",
                "submissionTypeId",
                "documentUploadFormDataPath"
            ]),
            admin: new Set([
                "*"
            ])
        }
    },
    ["documentUpload"]: {
        list: new Set([
            "*"
        ]),
        table: new Set([
            "view_only",
            "creator",
            "member",
            "manager",
            "admin"
        ]),
        view: {
            guest: new Set([
                "id",
                "name",
                "originalFilename",
                "mimeType",
                "url",
                "documentType",
                "issuedAt",
                "createdAt",
                "elevationCertificate",
                "accountDocumentType",
                "formData",
                "property",
                "documentUpload",
                "hiddenFromPublic",
                "certificateUpload",
                "isDeletable",
                "customMapGeometry",
                "objectType",
                "objectId",
                "hasAssociatedAIActionRun",
                "externalDocumentURL"
            ]),
            publicUser: new Set([
                "id",
                "name",
                "originalFilename",
                "mimeType",
                "url",
                "documentType",
                "issuedAt",
                "createdAt",
                "elevationCertificate",
                "accountDocumentType",
                "formData",
                "property",
                "documentUpload",
                "hiddenFromPublic",
                "certificateUpload",
                "isDeletable",
                "customMapGeometry",
                "objectType",
                "objectId",
                "hasAssociatedAIActionRun",
                "externalDocumentURL"
            ]),
            view_only: new Set([
                "*"
            ]),
            creator: new Set([
                "*"
            ]),
            member: new Set([
                "*"
            ]),
            manager: new Set([
                "*"
            ]),
            admin: new Set([
                "*"
            ])
        },
        view_details: new Set([
            "view_only",
            "creator",
            "member",
            "manager",
            "admin"
        ]),
        create: new Set([
            "guest",
            "publicUser",
            "creator",
            "member",
            "manager",
            "admin"
        ]),
        delete: new Set([
            "member",
            "manager",
            "admin"
        ]),
        hide: new Set([
            "creator",
            "member",
            "manager",
            "admin"
        ]),
        update: new Set([
            "creator",
            "member",
            "manager",
            "admin"
        ]),
        share: new Set([
            "view_only",
            "creator",
            "member",
            "manager",
            "admin"
        ])
    },
    ["featureFlag"]: {
        view: new Set([
            "guest",
            "publicUser",
            "view_only",
            "creator",
            "member",
            "manager",
            "admin"
        ]),
        update: new Set([
            "admin"
        ])
    },
    ["featuredContent"]: {
        view: new Set([
            "*"
        ])
    },
    ["firm"]: {
        create: new Set([
            "admin"
        ]),
        view: new Set([
            "*"
        ]),
        update: new Set([
            "creator",
            "member",
            "manager",
            "admin"
        ]),
        view_settings: new Set([
            "admin"
        ]),
        import: new Set([
            "admin"
        ])
    },
    ["generatedDocument"]: {
        create: new Set([
            "creator",
            "member",
            "manager",
            "admin"
        ]),
        update: new Set([
            "creator",
            "member",
            "manager",
            "admin"
        ])
    },
    ["userGroup"]: {
        list: new Set([
            "*"
        ]),
        view: new Set([
            "*"
        ]),
        create: new Set([
            "admin"
        ]),
        update: new Set([
            "admin"
        ]),
        delete: new Set([
            "admin"
        ])
    },
    ["healthCheck"]: {
        view: new Set([
            "*"
        ])
    },
    ["helpscoutBeacon"]: {
        view: new Set([
            "*"
        ]),
        update: new Set([
            "admin"
        ])
    },
    ["informationRequest"]: {
        find: new Set([
            "view_only",
            "creator",
            "member",
            "manager",
            "admin"
        ]),
        list: new Set([
            "view_only",
            "creator",
            "member",
            "manager",
            "admin"
        ]),
        view: {
            view_only: new Set([
                "*"
            ]),
            creator: new Set([
                "*"
            ]),
            member: new Set([
                "*"
            ]),
            manager: new Set([
                "*"
            ]),
            admin: new Set([
                "*"
            ])
        },
        public_create: new Set([
            "*"
        ]),
        private_create: new Set([
            "creator",
            "member",
            "manager",
            "admin"
        ]),
        update: new Set([
            "creator",
            "member",
            "manager",
            "admin"
        ]),
        export: new Set([
            "creator",
            "member",
            "manager",
            "admin"
        ]),
        delete: new Set([
            "member",
            "manager",
            "admin"
        ])
    },
    ["improvement"]: {
        view: {
            guest: new Set([
                "id",
                "progress",
                "description",
                "exclusion",
                "date",
                "value",
                "kind",
                "hiddenFromPublic"
            ]),
            publicUser: new Set([
                "id",
                "progress",
                "description",
                "exclusion",
                "date",
                "value",
                "kind",
                "hiddenFromPublic"
            ]),
            view_only: new Set([
                "*"
            ]),
            creator: new Set([
                "*"
            ]),
            member: new Set([
                "*"
            ]),
            manager: new Set([
                "*"
            ]),
            admin: new Set([
                "*"
            ])
        }
    },
    ["thirdPartySystemConfiguration"]: {
        create: new Set([
            "admin"
        ]),
        view: new Set([
            "admin"
        ]),
        update: new Set([
            "admin"
        ]),
        delete: new Set([
            "admin"
        ])
    },
    ["dataSettings"]: {
        create: new Set([
            "admin"
        ]),
        list: new Set([
            "admin"
        ]),
        view: new Set([
            "admin"
        ]),
        upload: new Set([
            "admin"
        ])
    },
    ["offlinePack"]: {
        list: new Set([
            "view_only",
            "creator",
            "member",
            "manager",
            "admin"
        ]),
        create: new Set([
            "view_only",
            "creator",
            "member",
            "manager",
            "admin"
        ]),
        update: new Set([
            "view_only",
            "creator",
            "member",
            "manager",
            "admin"
        ]),
        delete: new Set([
            "view_only",
            "creator",
            "member",
            "manager",
            "admin"
        ])
    },
    ["parcel"]: {
        find: new Set([
            "*"
        ]),
        view: {
            guest: new Set([
                "id",
                "lot",
                "block",
                "parcelId",
                "yearBuilt",
                "parcelId",
                "parcelValue",
                "landValue",
                "improvementValue",
                "buildingDescription",
                "owner",
                "legalDescription",
                "mailingAddress1",
                "mailingAddress2",
                "address",
                "additionalFields"
            ]),
            publicUser: new Set([
                "id",
                "lot",
                "block",
                "parcelId",
                "yearBuilt",
                "parcelId",
                "parcelValue",
                "landValue",
                "improvementValue",
                "buildingDescription",
                "owner",
                "legalDescription",
                "mailingAddress1",
                "mailingAddress2",
                "address",
                "additionalFields"
            ]),
            view_only: new Set([
                "*"
            ]),
            creator: new Set([
                "*"
            ]),
            member: new Set([
                "*"
            ]),
            manager: new Set([
                "*"
            ]),
            admin: new Set([
                "*"
            ])
        }
    },
    ["parcelImportTask"]: {
        create: new Set([
            "admin"
        ]),
        list: new Set([
            "admin"
        ]),
        view: new Set([
            "admin"
        ]),
        upload: new Set([
            "admin"
        ])
    },
    ["passwordReset"]: {
        view: new Set([
            "*"
        ])
    },
    ["parcelImportConfiguration"]: {
        view: INTERNAL_ROLES_SET,
        create: new Set([
            "admin"
        ]),
        update: new Set([
            "admin"
        ]),
        delete: new Set([
            "admin"
        ])
    },
    ["permit"]: {
        view: new Set([
            "view_only",
            "creator",
            "member",
            "manager",
            "admin"
        ]),
        update: new Set([
            "creator",
            "member",
            "manager",
            "admin"
        ])
    },
    ["property"]: {
        find: new Set([
            "*"
        ]),
        list: new Set([
            "*"
        ]),
        view: {
            guest: new Set([
                "id",
                "latitude",
                "longitude",
                "parcelId",
                "fullAddress",
                "streetAddress",
                "city",
                "state",
                "zipcode",
                "parcelDataRevisedDate",
                "coordinates",
                "standardizedAddress",
                "certificates",
                "description",
                "lot",
                "block",
                "documentUploads",
                "parcel",
                "improvementValue",
                "landValue",
                "parcelValue",
                "additionalFields",
                "streetViewEnabled",
                "coverImageDocumentUploadId",
                "firms",
                "hiddenFromPublic"
            ]),
            publicUser: new Set([
                "id",
                "latitude",
                "longitude",
                "parcelId",
                "fullAddress",
                "streetAddress",
                "city",
                "state",
                "zipcode",
                "parcelDataRevisedDate",
                "coordinates",
                "standardizedAddress",
                "certificates",
                "description",
                "lot",
                "block",
                "documentUploads",
                "parcel",
                "improvementValue",
                "landValue",
                "parcelValue",
                "additionalFields",
                "streetViewEnabled",
                "coverImageDocumentUploadId",
                "firms",
                "hiddenFromPublic"
            ]),
            view_only: new Set([
                "*"
            ]),
            creator: new Set([
                "*"
            ]),
            member: new Set([
                "*"
            ]),
            manager: new Set([
                "*"
            ]),
            admin: new Set([
                "*"
            ])
        },
        view_sisd: new Set([
            "*"
        ]),
        create: new Set([
            "creator",
            "member",
            "manager",
            "admin"
        ]),
        update: new Set([
            "creator",
            "member",
            "manager",
            "admin"
        ]),
        share: new Set([
            "creator",
            "member",
            "manager",
            "admin",
            "view_only"
        ]),
        merge: new Set([
            "admin"
        ]),
        delete: COMMON_DELETE_ROLES_SET,
        hide: new Set([
            "admin",
            "manager",
            "member"
        ])
    },
    ["propertyAttribute"]: {
        create: new Set([
            "admin"
        ]),
        delete: new Set([
            "admin"
        ]),
        update: new Set([
            "admin"
        ]),
        view: new Set([
            "*"
        ])
    },
    ["publicAccountPortal"]: {
        view: new Set([
            "*"
        ])
    },
    ["publicUser"]: {
        login: new Set([
            "*"
        ]),
        view: {
            guest: new Set([
                "id",
                "firstName",
                "lastName",
                "phone",
                "account"
            ]),
            publicUser: new Set([
                "*"
            ]),
            view_only: new Set([
                "*"
            ]),
            creator: new Set([
                "*"
            ]),
            member: new Set([
                "*"
            ]),
            manager: new Set([
                "*"
            ]),
            admin: new Set([
                "*"
            ])
        },
        update: new Set([
            "view_only",
            "member",
            "creator",
            "manager",
            "admin"
        ]),
        list: new Set([
            "admin",
            "manager"
        ]),
        impersonate: new Set([
            "admin"
        ]),
        updateUserPermissions: new Set([
            "admin",
            "manager"
        ]),
        export: new Set([
            "admin",
            "manager"
        ]),
        signup: new Set([
            "guest"
        ]),
        emailConfirmation: new Set([
            "*"
        ]),
        manageStatus: CREATOR_AND_UP_SET
    },
    ["raster"]: {
        view: new Set([
            "*"
        ]),
        create: new Set([
            "admin"
        ])
    },
    ["repetitiveLoss"]: {
        view: new Set([
            "admin",
            "manager",
            "member",
            "creator",
            "view_only"
        ]),
        view_settings: new Set([
            "admin"
        ]),
        update: new Set([
            "admin"
        ]),
        list: new Set([
            "admin"
        ]),
        export: new Set([
            "admin"
        ])
    },
    ["repetitiveLossImportJob"]: {
        import: new Set([
            "admin"
        ]),
        list: new Set([
            "admin"
        ]),
        upload: new Set([
            "admin"
        ])
    },
    ["root"]: {
        view: new Set([
            "admin"
        ])
    },
    ["ruleDefinition"]: {
        create: new Set([
            "admin"
        ]),
        delete: new Set([
            "admin"
        ]),
        update: new Set([
            "admin"
        ]),
        view: new Set([
            "*"
        ])
    },
    // Note - If we expose saved view to public, we'll need to
    // ensure the tiles endpoints apply hiddenFromPublic as needed
    ["savedView"]: {
        find: INTERNAL_ROLES_SET,
        view: new Set([
            "*"
        ]),
        list: new Set([
            "*"
        ]),
        queryAllData: INTERNAL_ROLES_SET,
        queryLockedDownData: new Set([
            "*"
        ]),
        create: CREATOR_AND_UP_SET,
        delete: CREATOR_AND_UP_SET,
        update: CREATOR_AND_UP_SET,
        updateVisibility: new Set([
            "admin",
            "manager"
        ]),
        export: INTERNAL_ROLES_SET
    },
    ["search"]: {
        view: new Set([
            "*"
        ])
    },
    ["securityConfiguration"]: {
        view: {
            guest: new Set([
                "id",
                "minimumPasswordLength",
                "multifactorAuthEnabled"
            ]),
            publicUser: new Set([
                "id",
                "minimumPasswordLength",
                "multifactorAuthEnabled",
                "sessionTimeoutMinutes"
            ]),
            view_only: new Set([
                "*"
            ]),
            creator: new Set([
                "*"
            ]),
            member: new Set([
                "*"
            ]),
            manager: new Set([
                "*"
            ]),
            admin: new Set([
                "*"
            ])
        }
    },
    ["scriptJob"]: {
        view: new Set([
            "admin"
        ]),
        list: new Set([
            "admin"
        ]),
        dispatch: new Set([
            "admin"
        ]),
        upload: new Set([
            "admin",
            "manager",
            "member",
            "creator",
            "view_only"
        ])
    },
    ["submission"]: {
        view: new Set([
            "*"
        ]),
        list: new Set([
            "admin",
            "manager",
            "member",
            "creator",
            "view_only"
        ]),
        update: new Set([
            "admin",
            "manager",
            "member",
            "creator"
        ]),
        delete: new Set([
            "admin",
            "manager",
            "member"
        ]),
        updateVisibility: new Set([
            "admin",
            "manager",
            "member"
        ]),
        export: new Set([
            "admin",
            "manager",
            "member",
            "creator"
        ]),
        table: new Set([
            "admin",
            "manager",
            "member",
            "creator",
            "view_only"
        ])
    },
    ["submissionType"]: {
        create: new Set([
            "admin",
            "manager"
        ]),
        update: new Set([
            "admin",
            "manager"
        ]),
        view: new Set([
            "*"
        ]),
        delete: new Set([
            "admin",
            "manager"
        ])
    },
    ["submissionSummary"]: {
        list: new Set([
            "*"
        ]),
        view: new Set([
            "*"
        ])
    },
    ["task"]: {
        view: INTERNAL_ROLES_SET,
        create: CREATOR_AND_UP_SET,
        update: CREATOR_AND_UP_SET,
        list: INTERNAL_ROLES_SET,
        delete: CREATOR_AND_UP_SET
    },
    ["transcriptionTask"]: {
        view: new Set([
            "admin"
        ]),
        update: new Set([
            "admin"
        ])
    },
    ["user"]: {
        login: new Set([
            "*"
        ]),
        view: {
            guest: new Set([
                "id",
                "firstName",
                "lastName",
                "phone",
                "account"
            ]),
            publicUser: new Set([
                "id",
                "firstName",
                "lastName",
                "phone",
                "account"
            ]),
            view_only: new Set([
                "*"
            ]),
            creator: new Set([
                "*"
            ]),
            member: new Set([
                "*"
            ]),
            manager: new Set([
                "*"
            ]),
            admin: new Set([
                "*"
            ])
        },
        update: new Set([
            "view_only",
            "member",
            "creator",
            "manager",
            "admin"
        ]),
        suspend: new Set([
            "admin",
            "manager"
        ]),
        list: new Set([
            "admin",
            "manager"
        ]),
        impersonate: new Set([
            "admin"
        ]),
        updateUserPermissions: new Set([
            "admin",
            "manager"
        ]),
        export: new Set([
            "admin",
            "manager"
        ])
    },
    ["userInvite"]: {
        accept: new Set([
            "*"
        ]),
        view: new Set([
            "*"
        ]),
        create: new Set([
            "manager",
            "admin"
        ]),
        delete: new Set([
            "manager",
            "admin"
        ]),
        bulkCreate: new Set([
            "admin"
        ])
    },
    ["publicUserInvite"]: {
        accept: new Set([
            "*"
        ]),
        view: new Set([
            "*"
        ])
    },
    ["issue"]: {
        view: new Set([
            "creator",
            "member",
            "manager",
            "admin"
        ]),
        create: new Set([
            "creator",
            "member",
            "manager"
        ])
    },
    ["mailing"]: {
        create: new Set([
            "creator",
            "member",
            "manager",
            "admin"
        ])
    },
    ["paginationInfo"]: {
        view: new Set([
            "*"
        ])
    },
    ["warning"]: {
        view: new Set([
            "*"
        ]),
        update: new Set([
            "admin",
            "manager",
            "member"
        ])
    },
    ["mobileVersion"]: {
        view: new Set([
            "*"
        ])
    },
    ["userDevice"]: {
        view: new Set([
            ...UserRoleNames,
            "admin"
        ]),
        create: new Set(UserRoleNames),
        update: new Set(UserRoleNames)
    },
    ["userDeviceLocation"]: {
        view: new Set([
            ...UserRoleNames,
            "admin"
        ]),
        create: new Set(UserRoleNames),
        list: new Set([
            "admin",
            "manager"
        ])
    },
    ["queryDescription"]: {
        export: INTERNAL_ROLES_SET,
        store: CREATOR_AND_UP_SET
    },
    ["aiAction"]: {
        run: CREATOR_AND_UP_SET,
        view: INTERNAL_ROLES_SET,
        list: INTERNAL_ROLES_SET
    },
    ["aiActionRun"]: {
        view: CREATOR_AND_UP_SET
    },
    ["aiFeedback"]: {
        create: CREATOR_AND_UP_SET
    },
    ["apiKey"]: {
        view: INTERNAL_ROLES_SET,
        list: new Set([
            "admin"
        ]),
        create: new Set([
            "admin"
        ]),
        update: new Set([
            "admin"
        ]),
        delete: new Set([
            "admin"
        ])
    },
    ["workflowDefinition"]: {
        view: new Set([
            "*"
        ])
    },
    ["workflow"]: {
        view: new Set([
            ...INTERNAL_ROLES,
            "publicUser"
        ]),
        initiate: INTERNAL_ROLES_SET,
        share: CREATOR_AND_UP_SET,
        update: CREATOR_AND_UP_SET,
        delete: COMMON_DELETE_ROLES_SET
    },
    ["workflowStep"]: {
        view: INTERNAL_ROLES_SET,
        create: CREATOR_AND_UP_SET
    }
};
const AllowedPermissionsForResourcesThatRequirePII = {
    // we use an allowed list here, so that any *new* permission
    // added to sensitive PII resources are defaulted to requiring
    // PII access. So, for instance, all non-job rep loss permissions require PII access,
    // since the "allowed list" is empty
    ["repetitiveLoss"]: new Set([
        "view_settings"
    ]),
    ["repetitiveLossImportJob"]: new Set([
        "list"
    ])
};
const ResourcesThatRequirePIIPerEnvironment = {
    staging: _object_spread_props(_object_spread({}, AllowedPermissionsForResourcesThatRequirePII), {
        // in staging, neither of these resources require PII access,
        // so we give them *no* list as opposed to an empty list
        // to indicate they aren't under PII restrictions
        ["repetitiveLoss"]: undefined,
        ["repetitiveLossImportJob"]: undefined
    }),
    test: AllowedPermissionsForResourcesThatRequirePII,
    production: AllowedPermissionsForResourcesThatRequirePII,
    development: AllowedPermissionsForResourcesThatRequirePII
};
const resourcePermissionRequiresPII = ({ resource, permission, environment })=>{
    const allowedPermissionsForResourceThatRequiresPII = ResourcesThatRequirePIIPerEnvironment[environment][resource];
    return allowedPermissionsForResourceThatRequiresPII && !allowedPermissionsForResourceThatRequiresPII.has(permission);
};

//# sourceMappingURL=data:application/json;base64,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